/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { useContext } from 'react';
import ConfigContext from '../config-provider/ConfigContext.js';

var useConfig = (function () {
  return useContext(ConfigContext);
});

export { useConfig as default };
//# sourceMappingURL=useConfig.js.map
